import { signal } from "@preact/signals-core";

/** Kept in sync by router.ts on every render (link click, back/forward, guard-approved
 * nav) — lets the shell's nav highlighting react to client-side navigation instead of
 * only reflecting whatever the path was when the shell was first built. */
export const currentPath = signal(location.pathname);
